<template lang="pug">
.memberView
  .arrow_icon(@click="$router.go(-1)")
    img(src="@/assets/images/arrow_left.svg", alt="alt")
  .membox
    img.user-pic(:src="$root.member.user_picture", alt="alt")
    //- .qr-box
      img(src="../assets/images/camera.svg", alt="alt")
  h1 {{ $root.member.name }} ( {{ $root.member.user_name }} )
  h2 會員Ｑr Code
  .qrCode-box 
    qrcode(:background="background" :size="size" :cls="qrCls" :value="qrText")

  p {{ time }}s 後重新刷新
</template>

<script>
import Qrcode from 'v-qrcode/src/index'
export default {
  name: "member-center",
  components: {
    Qrcode
  },
  data () {
    return {
      time: 60,
      qrCls: 'qrcode',
      qrText: '',
      size: 180,
      background: '#fff'
    };
  },
  created () {
    this.genMemberCode()
  },
  methods: {
    // 倒計時
    countTime () {
      this.time = this.time - 1
      if (this.time > 0) {
        setTimeout(() => {
          this.countTime()
        }, 1000);
      }
      else {
        this.time = 60
        this.genMemberCode()
      }
    },
    genMemberCode () {
      let vm = this
      this.$root.apis.getMemberQrcode(this.$root.member.user_lineId, function (_response) {
        vm.qrText = _response.body.data
      })
    }
  },
  mounted () {
    this.countTime()
  },
};
</script>
<style lang="sass" scoped>
body
  position: relative
.memberView
  background-color: #000
  height: 100%
  overflow: auto
  padding: 0 4vmin 0
  .arrow_icon
    position: absolute
    top: 6vmin
    left: 6.1vmin
  h1
    font-size: 9vmin
    font-weight: 700
    text-align: center
    color: #fff
    padding-top: 14.75vmin
  .membox
    width: 26.5vmin
    height: 27.25vmin
    margin-top: 26.5vmin
    margin-inline: auto
    background-color: #fff
    border-radius: 50%
    display: flex
    position: relative
    img
      margin-block: auto
    img.user-pic
      border-radius: 100%

    .qr-box
      width: 12.5vmin
      height: 12.5vmin
      border-radius: 50%
      background-color: #22F48F
      position: absolute
      right: 0
      bottom: -2vmin
      display: flex
      img
        margin-block: auto
  h1
  h2
    margin-top: 5vmin
    font-size: 5vmin
    text-align: center
    color: #fff
    margin-bottom: 5vmin
  .qrCode-box
    width: 200px
    height: 200px
    padding: 0px
    margin: auto
    background: #fff
    padding-left: 10px
    padding-top: 10px

  p 
    font-size: 4vmin
    font-weight: 400
    color: #fff
    text-align: center
    margin-top: 2vmin
    margin-bottom: 10vmin

</style>
